import { assertObserver } from "./typeGuards.js";
export function normalizeSubscriber(input) {
    if (input === undefined) {
        return undefined;
    }
    if (typeof input === "function") {
        return { next: input };
    }
    // TODO: Remove in production build
    assertObserver(input);
    return input;
}
